import { Type } from 'class-transformer';
import {
  IsDefined,
  IsNotEmptyObject,
  IsNumber,
  IsOptional,
  MaxLength,
  ValidateNested
} from 'class-validator';

/**
 * DTO object used to create / update BankingCashUp.
 * TODO: Maybe in the future separate create dto from update dto.
 */

export class ReportModel {
  @IsDefined() reconCash1: number;
  @IsDefined() reconCash2: number;
  @IsDefined() reconCreditCard1: number;
  @IsDefined() reconCreditCard2: number;
  @IsDefined() reconCreditCard3: number;
  @IsDefined() reconCreditCard4: number;
  @IsDefined() reconCreditCard5: number;

  @IsOptional()
  @IsDefined() 
  reconDeliveroo: number;

  @IsOptional()
  @IsDefined() 
  reconJustEat: number;

  @IsOptional()
  @IsDefined() 
  reconUber: number;

  @IsDefined() reconOwnOnline: number;
  @IsDefined() reconOtherOnline: number;

  @IsOptional()
  @IsDefined() 
  reconGiftCard: number;

  @IsDefined() reconHouseAccounts: number;
  @IsDefined() pettyCash: number;

  @IsOptional()
  @IsDefined() 
  reconTotalReconciled: number;

  @IsOptional()
  @IsDefined() 
  @IsNumber()
  reconTotalToReconcile: number;
}
export class BankingCashUpCreateAndUpdateDto {
  /**
   * Reports details.
   */
  @IsDefined()
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => ReportModel)
  report: ReportModel;

  @MaxLength(255)
  @IsOptional()
  note?: string;

  /**
   * Merchant owner of the cash up report.
   */
  @IsDefined()
  @IsNumber()
  merchantId: number;
}
